import script from "./Czgl.vue?vue&type=script&setup=true&lang=js"
export * from "./Czgl.vue?vue&type=script&setup=true&lang=js"

import "./Czgl.vue?vue&type=style&index=0&id=011fc3f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-011fc3f5"]])

export default __exports__